module.exports = __webpack_public_path__ + "static/media/instructivoac8.fe85d628.png";